export const useStyles = (theme) => ({
  root: {
    padding: 20,
  },
  body: {
    minHeight: "20vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
